import React from "react";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words"
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import {
  ColumnHeader,
  ColumnValuesMrgn,
  ImgRec  
} from "./../Components/BalanceDetailsTable/styles.js";
import TransactionDetailsTable from "./../Components/TransactionDetailsTable/TransactionDetailsTable.js";
import CardComponent from "./../Components/CardComponent/CardComponent.js";
import recurringIcon from "./../../../assets/icons/recurring-icon.svg";
import TitleNode from "./../Components/CardComponent/TitleNode.js";
import { DataVal, TxnVal } from "./../Components/CardComponent/styles.js";
import { selectHeader } from "../../../actions/globalActions";
import history from "./../../../history/history";
import formatter from './../../../utils/formatter';
import { milliToDate, checkIEBrowser, recordError } from './../../../utils/commonUtil';
import { isIfTiff, isIfLcp } from './../Pages/txnUitls';
import { TableData } from "./TransactionDetailsTable/styles.js";
import { renderDate } from "../Pages/txnUitls";
import { exportTxnData } from "../Pages/actions";
import { replaceSelect } from "../../../utils/replacer";

export const renderTxnViewMob = function (txnId, data, searchText) {
  const isLCP = data.isLcpIncluded;
  return (
    <>
      <TxnVal isDisabled={isLCP} onClick={!isLCP ? () => viewExchange(txnId, data) : null}>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={txnId}>
          {txnId}
        </Highlighter>
      </TxnVal>
    </>
  )
}

export const renderTxnView = function (txnId, data, searchText) {
  const isLCP = data.isLcpIncluded
  if (txnId) {
    return (
      <>
        <TxnVal isDisabled={isLCP} onClick={!isLCP ? () => viewExchange(txnId, data) : null}>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={txnId}>
            {txnId}
        </Highlighter>
        </TxnVal>
      </>
    )
  } else {
    return (<TxnVal>-</TxnVal>)
  }
}

export const viewExchange = (id, data) => {
  try {
    if (data.tiffType === 'into') {
      history.push(`/view-edit-tiff-into/${id}/view`);
    } else if (data.tiffType === 'from') {
      history.push(`/view-edit-tiff-from/${id}/view`);
    } else {
      history.push(`/investments/recommend-an-exchange/${id}/view?type=onetime`);
    }
  } catch (error) {
    recordError(error);
  }
};

export const renderOption = (data, searchText) => {
  let divArray = []
  if (data.option && data.option.length > 0) {
    data.option.map((opt) => {
      divArray.push(
        opt.pool ?            
          <TableData ie={checkIEBrowser()}>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={replaceSelect(opt.pool)}>
              {replaceSelect(opt.pool)}
            </Highlighter>
          </TableData>            
          : <TableData>-</TableData>
      )
    })
  }
  if (data.value && data.value.length > 0) {
    data.value.map((val) => {
      let amount = 0;
      amount = formatter({
        value: val.value,
        fieldSuffix: 'Dollars',
      })
      if (data.type === 'from') {
        divArray.push(
          amount ?              
            <TableData ie={checkIEBrowser()}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={`(${amount})`}>
                {amount}
              </Highlighter>
            </TableData>              
            : <TableData>-</TableData>
        )
      } else {
        divArray.push(
          amount ?              
            <TableData ie={checkIEBrowser()}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={amount}>
                {amount}
              </Highlighter>
            </TableData>              
            : <TableData>-</TableData>
        )
      }
    })
  }

  return divArray;
}

export const renderTitleGrid = pool => {
  return (
    <>
      <TitleNode title='Entered Date' />
      <DataVal>{milliToDate(pool)}</DataVal>
    </>
  )
};

export const renderRecurring = (recur) => {
  if (recur) {
    return (
      <img src={recurringIcon} alt="Recurring" />
    )
  }
}

export const renderFixGrid = ({ each, gridName, type }, searchText) => {
  let gridData = [];
  switch (type) {
    case 'investmentOption':
      let data = each.investmentOption
      gridData.push(<TitleNode title="Pool(s)" />)
      if (data.option && data.option.length > 0) {
        data.option.map((opt) => {
          gridData.push(
            <ColumnValuesMrgn>
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={replaceSelect(opt.pool)}>
                  {replaceSelect(opt.pool)}
                </Highlighter>
              </DataVal>
            </ColumnValuesMrgn>
          )
        })
      }
      break;
    case 'value':
      // braking for test cases so data changed to dataValue
      let dataValue = each.value
      gridData.push(<TitleNode title="Dollar" />)
      if (dataValue.value && dataValue.value.length > 0) {
        dataValue.value.map((val) => {
          let amount = 0;
          amount = formatter({
            value: val.value,
            fieldSuffix: 'Dollars',
          })
          if (dataValue.type === 'from') {
            gridData.push(<ColumnValuesMrgn>
              <DataVal>
                (<Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={amount}>
                  {amount}
                </Highlighter>)
              </DataVal>
            </ColumnValuesMrgn>)
          } else {
            gridData.push(<ColumnValuesMrgn>
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={amount}>
                  {amount}
                </Highlighter>
              </DataVal>
            </ColumnValuesMrgn>)
          }
        })
      }
      break;
    case 'date':
      gridData.push(
        <div>
          <TitleNode title={gridName} />
          <DataVal>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={milliToDate(each[gridName])}>
              {milliToDate(each[gridName])}
            </Highlighter>
          </DataVal>
        </div>
      )
      break;
    default:
      gridData.push(
        <div>
          <TitleNode title={gridName} />
          <DataVal>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={each[gridName]}>
              {each[gridName]}
            </Highlighter>
          </DataVal>
        </div>
      )
      break;
  }
  return gridData;
};

export const ExchangeTable = ({searchText, exchangesData, exportTxnData}) => {

  const columns = [
    {
      title: <ColumnHeader>Transaction ID</ColumnHeader>,
      render: (txnId, data) => renderTxnView(txnId, data, searchText),
      dataIndex: "transactionId",
      key: "transactionId",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.transactionId.localeCompare(b.transactionId) }
    },
    {
      title: <ColumnHeader>Entered Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "enteredDate",
      key: "enteredDate",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.enteredDate - b.enteredDate }
    },
    {
      title: <ColumnHeader>Investment Option</ColumnHeader>,
      render: (data) => renderOption(data, searchText),
      dataIndex: "investmentOption",
      key: "investmentOption",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.option.localeCompare(b.option) }
    },
    {
      title: <ColumnHeader>Amount</ColumnHeader>,
      render: (data) => renderOption(data, searchText),
      dataIndex: "value",
      key: "value",      
      width: 130,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => {
        let aTotalOptionAmount = 0;
        let bTotalOptionAmount = 0;
        if (a.investmentOption.option && a.investmentOption.option.length > 0) {
          a.investmentOption.option.map((data) => {
            aTotalOptionAmount += Number(data.value)
          });
        };
        if (b.investmentOption.option && b.investmentOption.option.length > 0) {
          b.investmentOption.option.map((data) => {
            bTotalOptionAmount += Number(data.value)
          });
        };
        return aTotalOptionAmount - bTotalOptionAmount;
      }
    },
    {
      title: <ColumnHeader>Trade Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "tradeDate",
      key: "tradeDate",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.tradeDate - b.tradeDate }
    },
    {
      title: null,
      dataIndex: "recur",
      key: "recur",
      width: 100
    }
  ];

  const destObj = (each) => {
    return [
      {
        name: "transactionId",
        type: "FixGrid",
        gridWidth: "50",
        render: renderTxnViewMob(each['transactionId'], each, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "enteredDate",
        gridWidth: "100",
        type: "FixGrid",
        render: renderTitleGrid(each.enteredDate),
        ptop: true,
        pbottom: true,
        pright: true
      },
      {
        name: "InvestmentOption",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({
          each,
          gridName: "InvestmentOption",
          type: 'investmentOption'
        }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "Amount",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({
          each,
          gridName: "Value",
          type: 'value'
        }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "TradeDate",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "tradeDate", type: 'date' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "recur",
        type: "FixGrid",
        gridWidth: "100",
        render: renderRecurring(each.recurring),
        ptop: true,
        pbottom: true,
        pleft: true
      }
    ];
  };

  let modifiedExchangesData = [];
  exchangesData &&
    exchangesData.map(val => {
      if (val.fromInvestmentOption) {
        modifiedExchangesData.push({
          enteredDate: val.enteredDate,
          investmentOption: { 'type': 'from', 'option': val.fromInvestmentOption },
          //As for bug id 6631, fromInvestmentOption is coming empty array from API
          option: val.fromInvestmentOption.length > 0 ? val.fromInvestmentOption[0].pool : "-",
          amount: val.fromInvestmentOption.length > 0 ? val.fromInvestmentOption[0].value : 0,
          value: { 'type': 'from', 'value': val.fromInvestmentOption },
          tradeDate: val.tradeDate,
          transactionId: val.transactionId,
          recur: val.recurring ? <TableData><ImgRec><img src={recurringIcon} alt="Recurring" /></ImgRec></TableData> : <TableData></TableData>,
          tiffType: val.tiff && isIfTiff(val.fromInvestmentOption) ? 'from' : null,
          allocationType: val.allocationType,
          exchangesType: val.exchangesType,
          recurring: val.recurring,
          status: val.status,
          isLcpIncluded: isIfLcp(val.toInvestmentOption || []) || isIfLcp(val.fromInvestmentOption)
        });
      }
      if (val.toInvestmentOption) {
        modifiedExchangesData.push({
          enteredDate: val.enteredDate,
          investmentOption: { 'type': 'to', 'option': val.toInvestmentOption },
          option: val.toInvestmentOption[0].pool,
          amount: val.toInvestmentOption[0].value,
          value: { 'type': 'to', 'value': val.toInvestmentOption },
          tradeDate: val.tradeDate,
          transactionId: val.transactionId,
          recur: val.recurring ? <TableData><ImgRec><img src={recurringIcon} alt="Recurring" /></ImgRec></TableData> : <TableData></TableData>,
          tiffType: val.tiff && isIfTiff(val.toInvestmentOption) ? 'into' : null,
          allocationType: val.allocationType,
          exchangesType: val.exchangesType,
          recurring: val.recurring,
          status: val.status,
          isLcpIncluded: isIfLcp(val.toInvestmentOption) || isIfLcp(val.fromInvestmentOption || [])
        });
      }
    });

    exportTxnData({ tab: 'Exchanges', data: modifiedExchangesData })

  return (
    <Row id="table-search-exchanges" data-test="transaction-exchange-table">
      <Col lg={24} md={0} xs={0}>
        <TransactionDetailsTable data-test="transaction-exchange-table-desktop" className="exchangeTab" tabIdentifier="Exchanges" tabName="exchange" scroll={{ y: 500 }} columns={columns} data={modifiedExchangesData} searchText={searchText} />
      </Col>
      <Col lg={0} md={24} xs={24} className="mobCard">
        <CardComponent data-test="transaction-exchange-table-mobile" tabName="exchange" destObj={destObj} data={modifiedExchangesData} searchText={searchText} />
      </Col>
    </Row>
  );
};

ExchangeTable.propTypes = {
  searchText: PropTypes.string,
  exchangesData: PropTypes.array
}

const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
    exportTxnData: data => dispatch(exportTxnData(data)),
  };
};

export default connect(null, mapDispatchToProps)(ExchangeTable);
